/**
 * StandRolRozeti.jsx — "bu firma bu standda hangi rolde" rozeti (backlog #425 / #424, backend #423).
 *
 * Firma portalı stand listesini firmaId ile ister (firmanın o fuardaki HER rolü); her satır
 * firmaRolleri ["KATILIMCI" | "DEKORATOR" | "TASERON"] taşır (standOverviewService.mapRosterRow).
 * Aynı firma bir standda Katılımcı, diğerinde Dekoratör olabilir (#409 D6) — rozet satırın kendi rolünü gösterir.
 * Rol bilinmiyorsa (mock veri, staff listeleri) hiçbir şey çizilmez.
 *
 * Adlar portal:arayuz.* anahtarlarından (tr/en zaten var) — yeni metin yok.
 */
import React from "react";
import { Badge } from "reactstrap";
import { useTranslation } from "react-i18next";

/** Satırın rolleri bilinmiyorsa true — sayfalar bunu "Dekoratör varsay" diye okur (eski davranış). */
export const standRolleriBilinmiyor = (record) =>
  !Array.isArray(record?.firmaRolleri) || record.firmaRolleri.length === 0;

/** Firma bu standda Dekoratör mü? Roller bilinmiyorsa eski davranış: evet (mock / decoratorFirmaId'li çağrı). */
export const standdaDekorator = (record) =>
  standRolleriBilinmiyor(record) || record.firmaRolleri.includes("DEKORATOR");

export default function StandRolRozeti({ record, className = "" }) {
  const { t } = useTranslation("portal");
  if (standRolleriBilinmiyor(record)) return null;
  return (
    <span className={className}>
      {record.firmaRolleri.map((rol) => (
        <Badge key={rol} color="light" className="text-body border fw-normal me-1">
          {t(`arayuz.${rol}`, rol)}
        </Badge>
      ))}
    </span>
  );
}
